import KEYS from '@/values/keys';
import { FOOTER_TYPE } from '@/core/values/core.values';

import EdLessonCreateFile from '../pages/create-lesson/modals/ed-lesson-create-file/ed-lesson-create-file.vue';
import EdLessonCreateVideo from '../pages/create-lesson/modals/ed-lesson-create-video/ed-lesson-create-video.vue';
import EdLessonCreateLink from '../pages/create-lesson/modals/ed-lesson-create-link/ed-lesson-create-link.vue';
import EdLessonCreateImage from '../pages/create-lesson/modals/ed-lesson-create-image/ed-lesson-create-image.vue';

/* Text object */
import EdCreateTextObject from '@/courses/components/text-object/ed-create-text-object/ed-create-text-object.vue';
import EdTextViewer from '@/content/pages/course-viewer/components/ed-text-viewer/ed-text-viewer.vue';

/* Course Material Object Components */
import EdCourseCreateCourseMaterialObject from '@/courses/components/course-material-object/ed-course-craate-course-material-object/ed-course-create-course-material-object.vue';
import EdHomeworkCourseMaterialObject from '@/courses/components/course-material-object/ed-homework-course-material-object/ed-homework-course-material-object.vue';
import EdResponseCourseMaterialObject from '@/courses/components/course-material-object/ed-response-course-material-object/ed-response-course-material-object.vue';
import EdMaterialViewer from '@/courses/components/ed-material-viewer/ed-material-viewer.vue';

/* Write Object */
import EdCourseCreateWriteObject from '@/courses/components/ed-course-create-write-object/ed-course-create-write-object.vue';
import EdViewerWriteObject from '@/courses/components/ed-viewer-write-object/ed-viewer-write-object.vue';
import EdHomeworkWriteObject from '@/courses/components/ed-homework-write-object/ed-homework-write-object.vue';
import EdViewerResponseWriteObject from '@/courses/components/ed-viewer-response-write-object/ed-viewer-response-write-object.vue';

/* File Object Components */
import EdCourseCreateFileObject from '@/courses/components/file-object/ed-course-create-file-object/ed-course-create-file-object.vue';
import EdHomeworkFileObject from '@/courses/components/file-object/ed-homework-file-object/ed-homework-file-object.vue';
import EdViewerResponseFileObject from '@/courses/components/file-object/ed-viewer-response-file-object/ed-viewer-response-file-object.vue';

/* Type Object Components */
import EdCourseCreateTypeObject from '@/courses/components/type-object/ed-course-create-type-object/ed-course-create-type-object.vue';
import EdViewerTypeObject from '@/courses/components/type-object/ed-viewer-type-object/ed-viewer-type-object.vue';
import EdHomeworkTypeObject from '@/courses/components/type-object/ed-homework-type-object/ed-homework-type-object.vue';
import EdViewerResponseTypeObject from '@/courses/components/type-object/ed-viewer-response-type-object/ed-viewer-response-type-object.vue';

/* Multimedia objects */
import EdCourseCreateMultimediaObject from '@/courses/components/multimedia-objects/ed-course-create-multimedia-object/ed-course-create-multimedia-object.component.vue';
/* Audio Object Components */
import EdViewerAudioObjectComponent from '@/courses/components/multimedia-objects/audio-object/ed-viewer-audio-object/ed-viewer-audio-object.component.vue';
/* Video object Components */
import EdViewerVideoObjectComponent from '@/courses/components/multimedia-objects/video-object/ed-viewer-video-object/ed-viewer-video-object.component.vue';

/* Other Files Componentns */
import EdCourseCreateOtherFilesObject from '@/courses/components/other-files-object/ed-course-create-other-files-object/ed-course-create-other-files-object.vue';

/* Deck components */
import EdCourseCreateSubDeckObject from '@/courses/components/flash-cards/ed-course-create-subdeck-object/ed-course-create-subdeck-object.vue';
import EdSubdeckViewer from '@/courses/components/flash-cards/ed-subdeck-viewer/ed-subdeck-viewer.component.vue';

/* Lessons by Zip */
import EdCourseCreateZipStructureObject from '@/courses/components/file-object/ed-course-create-zip-structure-object/ed-course-create-zip-structure-object.vue';


export const SECTION_TYPES = {
  SECTION: {
    code: 'SECTION',
    icon: 'folder',
    extensions: []
  },
  SECTION_LESSON: {
    code: 'LESSON',
    icon: 'folder-solid',
    extensions: []
  },
  SECTION_LINK: {
    code: 'LINK',
    icon: 'mdi-link',
    extensions: []
  },
  PROJECT: {
    code: 'PROJECT',
    icon: 'folder',
    extensions: []
  },
  CARD: {
    code: 'CARD',
    icon: 'deck',
    extensions: []
  },
  LESSON_TEMP_FILE: {
    code: 'LESSON_TEMP_FILE',
    icon: 'file',
    modal: EdCourseCreateFileObject,
    viewer: 'EdFileViewer',
    viewerFooter: FOOTER_TYPE.NONE,
    extensions: [],
    groupName: 'file'
  },
  LESSON_PDF: {
    code: 'LESSON_PDF',
    icon: 'file',
    modal: EdCourseCreateFileObject,
    viewer: 'EdFileViewer',
    viewerFooter: FOOTER_TYPE.NONE,
    viewerHomework: EdHomeworkFileObject,
    viewerResponse: EdViewerResponseFileObject,
    extensions: [KEYS.FILES_TYPE.PDF],
    groupName: 'file'
  },
  LESSON_DOC: {
    code: 'LESSON_DOC',
    icon: 'file',
    modal: EdCourseCreateFileObject,
    viewer: 'EdFileViewer',
    viewerFooter: FOOTER_TYPE.NONE,
    viewerHomework: EdHomeworkFileObject,
    viewerResponse: EdViewerResponseFileObject,
    extensions: [KEYS.FILES_TYPE.DOC, KEYS.FILES_TYPE.DOCX],
    groupName: 'file'
  },
  LESSON_DOCX: {
    code: 'LESSON_DOCX',
    icon: 'file',
    modal: EdCourseCreateFileObject,
    viewer: 'EdFileViewer',
    viewerFooter: FOOTER_TYPE.NONE,
    viewerHomework: EdHomeworkFileObject,
    viewerResponse: EdViewerResponseFileObject,
    extensions: [KEYS.FILES_TYPE.DOCX],
  },
  LESSON_EPUB: {
    code: 'LESSON_EPUB',
    icon: 'file',
    modal: EdCourseCreateFileObject,
    viewer: 'EdFileViewer',
    viewerFooter: FOOTER_TYPE.NONE,
    viewerHomework: EdHomeworkFileObject,
    viewerResponse: EdViewerResponseFileObject,
    extensions: [KEYS.FILES_TYPE.EPUB],
    groupName: 'file'
  },
  LESSON_XLS: {
    code: 'LESSON_XLS',
    icon: 'file',
    modal: EdCourseCreateFileObject,
    viewer: 'EdFileViewer',
    viewerFooter: FOOTER_TYPE.NONE,
    viewerHomework: EdHomeworkFileObject,
    viewerResponse: EdViewerResponseFileObject,
    extensions: [KEYS.FILES_TYPE.XLS, KEYS.FILES_TYPE.XLSX],
    groupName: 'file'
  },
  LESSON_XLSX: {
    code: 'LESSON_XLSX',
    icon: 'file',
    modal: EdCourseCreateFileObject,
    viewer: 'EdFileViewer',
    viewerFooter: FOOTER_TYPE.NONE,
    viewerHomework: EdHomeworkFileObject,
    viewerResponse: EdViewerResponseFileObject,
    extensions: [KEYS.FILES_TYPE.XLSX],
  },
  LESSON_PPT: {
    code: 'LESSON_PPT',
    icon: 'file',
    modal: EdCourseCreateFileObject,
    viewer: 'EdFileViewer',
    viewerFooter: FOOTER_TYPE.NONE,
    viewerHomework: EdHomeworkFileObject,
    viewerResponse: EdViewerResponseFileObject,
    extensions: [KEYS.FILES_TYPE.PPT, KEYS.FILES_TYPE.PPTX],
    groupName: 'file'
  },
  LESSON_PPTX: {
    code: 'LESSON_PPTX',
    icon: 'file',
    modal: EdCourseCreateFileObject,
    viewer: 'EdFileViewer',
    viewerFooter: FOOTER_TYPE.NONE,
    viewerHomework: EdHomeworkFileObject,
    viewerResponse: EdViewerResponseFileObject,
    extensions: [KEYS.FILES_TYPE.PPTX],
  },
  LESSON_FILE: {
    code: 'LESSON_TEMP_FILE',
    icon: 'file',
    modal: EdLessonCreateFile,
    viewer: 'EdFileViewer',
    viewerFooter: FOOTER_TYPE.NONE,
    extensions: [],
    groupName: 'file'
  },
  LESSON_EXTERNAL_LINK: {
    code: 'LESSON_EXTERNAL_LINK',
    icon: 'link',
    modal: EdLessonCreateLink,
    viewer: 'EdLinkViewer',
    viewerFooter: FOOTER_TYPE.NONE,
    viewerHomework: 'EdLinkViewer',
    extensions: []
  },
  LESSON_VIDEO: {
    code: 'LESSON_VIDEO',
    icon: 'play',
    modal: EdLessonCreateVideo,
    viewer: 'EdVideoViewer',
    viewerFooter: FOOTER_TYPE.COMPACT,
    viewerHomework: 'EdVideoViewer',
    extensions: []
  },
  LESSON_IMAGES: {
    code: 'LESSON_IMAGES',
    icon: 'image',
    modal: EdLessonCreateImage,
    viewer: 'EdImagesViewer',
    viewerHomework: 'EdImagesViewer',
    viewerResponse: 'EdImagesViewer',
    viewerFooter: FOOTER_TYPE.COMPACT,
    extensions: []
  },
  LESSON_TEXT: {
    code: 'LESSON_TEXT',
    icon: 'font',
    modal: EdCreateTextObject,
    viewer: 'EdFileViewer',
    viewerFooter: FOOTER_TYPE.COMPACT,
    viewerHomework: EdHomeworkFileObject,
    viewerResponse: EdViewerResponseFileObject,
    extensions: []
  },
  LESSON_MATERIAL: {
    code: 'LESSON_MATERIAL',
    icon: 'section',
    modal: EdCourseCreateCourseMaterialObject,
    viewer: EdMaterialViewer,
    viewerAudioMaterial: EdViewerAudioObjectComponent,
    viewerVideoMaterial: EdViewerVideoObjectComponent,
    viewerHomework: EdHomeworkCourseMaterialObject,
    viewerFooter: FOOTER_TYPE.NONE,
    viewerResponse: EdResponseCourseMaterialObject,
    extensions: [KEYS.FILES_TYPE.PDF]
  },
  LESSON_SPLIT_WRITE: {
    code: 'LESSON_SPLIT_WRITE',
    icon: 'columns',
    modal: EdCourseCreateWriteObject,
    viewer: EdViewerWriteObject,
    viewerHomework: EdHomeworkWriteObject,
    viewerResponse: EdViewerResponseWriteObject,
    viewerFooter: FOOTER_TYPE.NONE,
    extensions: []
  },
  LESSON_BOARD: {
    code: 'BOARD'
  },
  SPLIT_QUESTION_PDF: {
    code: 'SPLIT_QUESTION_PDF',
    extensions: [KEYS.FILES_TYPE.PDF]
  },
  SPLIT_SOLUTION_PDF: {
    code: 'SPLIT_SOLUTION_PDF',
    extensions: [KEYS.FILES_TYPE.PDF]
  },
  SPLIT_QUESTION_MATERIAL: {
    code: 'SPLIT_QUESTION_MATERIAL',
    extensions: [KEYS.FILES_TYPE.PDF]
  },
  SPLIT_SOLUTION_MATERIAL: {
    code: 'SPLIT_SOLUTION_MATERIAL',
    extensions: [KEYS.FILES_TYPE.PDF]
  },
  LESSON_SPLIT_TYPE: {
    code: 'LESSON_SPLIT_TYPE',
    icon: 'keyboard-solid',
    modal: EdCourseCreateTypeObject,
    viewer: EdViewerTypeObject,
    viewerHomework: EdHomeworkTypeObject,
    viewerResponse: EdViewerResponseTypeObject,
    viewerFooter: FOOTER_TYPE.NONE,
    extensions: []
  },
  LESSON_MULTIMEDIA_FILES: {
    code: 'LESSON_MULTIMEDIA_FILES',
    icon: 'headphones',
    modal: EdCourseCreateMultimediaObject
  },
  LESSON_AUDIO_FILE: {
    code: 'LESSON_AUDIO_FILE',
    icon: 'file-audio',
    viewer: EdViewerAudioObjectComponent,
    modal: EdCourseCreateMultimediaObject,
    viewerFooter: FOOTER_TYPE.NONE,
  },
  LESSON_VIDEO_FILE: {
    code: 'LESSON_VIDEO_FILE',
    icon: 'file-video-solid',
    viewer: EdViewerVideoObjectComponent,
    modal: EdCourseCreateMultimediaObject,
    viewerFooter: FOOTER_TYPE.NONE,
  },
  LESSON_OTHER_FILE: {
    code: 'LESSON_OTHER_FILE',
    icon: 'file-solid',
    modal: EdCourseCreateOtherFilesObject,
    viewer: 'EdOtherFilesViewer',
    viewerFooter: FOOTER_TYPE.NONE,
    extensions: [],
    groupName: 'file'
  },
  LESSON_PPT_HTML: {
    code: 'LESSON_PPT_HTML',
    icon: 'file',
    modal: EdCourseCreateFileObject,
    viewer: 'EdFileViewer',
    viewerFooter: FOOTER_TYPE.NONE,
    extensions: [KEYS.FILES_TYPE.ZIP],
    groupName: 'file'
  },
  LESSON_ZIP: {
    code: 'LESSON_ZIP',
    icon: 'file-archive-zip',
    modal: EdCourseCreateZipStructureObject,
    extensions: [KEYS.FILES_TYPE.ZIP],
    groupName: 'file'
  },
  LESSON_PDF_IMAGE: {
    code: 'LESSON_PDF_IMAGE',
    icon: 'file',
    modal: EdCourseCreateFileObject,
    viewer: 'EdScanImagesViewer',
    viewerFooter: FOOTER_TYPE.NONE,
    viewerHomework: EdHomeworkFileObject,
    viewerResponse: EdViewerResponseFileObject,
    extensions: [],
    groupName: 'file'
  },
  CARDS_DECK: {
    code: 'CARDS_DECK',
    icon: 'deck',
  },
  CARDS: {
    code: 'CARDS',
    modal: '',
  },
  CARD_IMAGE: {
    code: 'CARD_IMAGE',
  },
  CARD_TEXT: {
    code: 'CARD_TEXT',
  },
  SUBDECK: {
    code: 'SUBDECK',
    icon: 'deck',
    modal: EdCourseCreateSubDeckObject,
    viewer: EdSubdeckViewer,
  },
};

export const SPLIT_SUTBTYPES = [SECTION_TYPES.SPLIT_QUESTION_PDF.code,
        SECTION_TYPES.SPLIT_SOLUTION_PDF.code,
        SECTION_TYPES.SPLIT_QUESTION_MATERIAL.code,
        SECTION_TYPES.SPLIT_SOLUTION_MATERIAL.code,];

export const SECTION_OPTIONS = [
   { ...SECTION_TYPES.LESSON_FILE, type: 'file' },
];

export const SECTION_OPTIONS_TEACHER = [
  { ...SECTION_TYPES.LESSON_TEMP_FILE, type: 'file'             },
  { ...SECTION_TYPES.SECTION, type: 'folder'                    },
  { ...SECTION_TYPES.LESSON_IMAGES, type: 'image'               },
  { ...SECTION_TYPES.SECTION_LESSON, type: 'lesson'             },
  { ...SECTION_TYPES.LESSON_EXTERNAL_LINK, type: 'link'         },
  { ...SECTION_TYPES.LESSON_MULTIMEDIA_FILES, type: 'multimedia'},
  { ...SECTION_TYPES.LESSON_OTHER_FILE, type: 'otherFilesApp'   },
  { ...SECTION_TYPES.SUBDECK, type: 'subdeck'                   },
  { ...SECTION_TYPES.LESSON_MATERIAL,  type: 'courseMaterial'   },
  { ...SECTION_TYPES.LESSON_TEXT,  type: 'text'                 },
  { ...SECTION_TYPES.LESSON_SPLIT_TYPE, type: 'type'            },
  { ...SECTION_TYPES.LESSON_VIDEO, type: 'video'                },
  { ...SECTION_TYPES.LESSON_SPLIT_WRITE, type: 'write'          },
  { ...SECTION_TYPES.LESSON_ZIP, type: 'zipLesson'              },
];

export const SECTION_OPTIONS_CONTENT = [
  { ...SECTION_TYPES.SECTION, type: 'folder'                    },
  { ...SECTION_TYPES.LESSON_ZIP, type: 'zipLesson'              },
];

export const SECTION_OPTIONS_ROOT_TEMPLATES = [
  { ...SECTION_TYPES.SECTION, type: 'folder'                    },
  { ...SECTION_TYPES.SECTION_LESSON, type: 'lesson'             },
];

export const SECTION_OPTIONS_ROOT_DECK_LIBRARY = [
  { ...SECTION_TYPES.CARDS_DECK, type: 'deck'               },
];

export const SECTION_COMMONS = {
  SECTION_LIST: 'SECTION_LIST',
  SECTION_PARENT_LIST: 'parent-group',
};

export const PROJECT_COMMONS = {
  PROJECT_LIST: 'PROJECT_LIST',
  PROJECT_PARENT_LIST: 'project-parent-group',
};

export const SECTIONS_TYPE_FILE = [
  SECTION_TYPES.LESSON_EPUB.code,
  SECTION_TYPES.LESSON_TEMP_FILE.code,
  SECTION_TYPES.LESSON_PDF.code,
  SECTION_TYPES.LESSON_DOC.code,
  SECTION_TYPES.LESSON_DOCX.code,
  SECTION_TYPES.LESSON_XLS.code,
  SECTION_TYPES.LESSON_XLSX.code,
  SECTION_TYPES.LESSON_PPT.code,
  SECTION_TYPES.LESSON_PPTX.code,
  SECTION_TYPES.LESSON_IMAGES.code,
  SECTION_TYPES.LESSON_PPT_HTML.code,
  SECTION_TYPES.LESSON_PDF_IMAGE.code,
]

export const SECTIONS_TYPE_FILE_DOWLOAD = [
  SECTION_TYPES.LESSON_EPUB.code,
  SECTION_TYPES.LESSON_TEMP_FILE.code,
  SECTION_TYPES.LESSON_PDF.code,
  SECTION_TYPES.LESSON_DOC.code,
  SECTION_TYPES.LESSON_DOCX.code,
  SECTION_TYPES.LESSON_XLS.code,
  SECTION_TYPES.LESSON_XLSX.code,
  SECTION_TYPES.LESSON_PPT.code,
  SECTION_TYPES.LESSON_PPTX.code,
  SECTION_TYPES.LESSON_IMAGES.code,
  SECTION_TYPES.LESSON_MATERIAL.code,
  SECTION_TYPES.LESSON_SPLIT_WRITE.code,
  SECTION_TYPES.LESSON_SPLIT_TYPE.code,
  SECTION_TYPES.LESSON_TEXT.code,
]

export const TYPE_TEXT_DRAFT_RESPONSE_OPTIONS = [
  SECTION_TYPES.LESSON_SPLIT_TYPE.code,
  SECTION_TYPES.LESSON_TEXT.code
];

export const TYPE_BOARD_DRAFT_RESPONSE_OPTIONS = [
  SECTION_TYPES.LESSON_MATERIAL.code,
  SECTION_TYPES.LESSON_PDF.code,
  SECTION_TYPES.LESSON_SPLIT_WRITE.code,
  SECTION_TYPES.LESSON_XLS.code,
  SECTION_TYPES.LESSON_XLSX.code,
  SECTION_TYPES.LESSON_PPT.code,
  SECTION_TYPES.LESSON_PPTX.code,
  SECTION_TYPES.LESSON_DOC.code,
  SECTION_TYPES.LESSON_DOCX.code,
  SECTION_TYPES.LESSON_PDF_IMAGE.code,
  SECTION_TYPES.LESSON_TEXT.code
];

export const TYPE_BOARD_DRAFT_FEEDBACK_OPTIONS = [
  SECTION_TYPES.LESSON_MATERIAL.code,
  SECTION_TYPES.LESSON_PDF.code,
  SECTION_TYPES.LESSON_SPLIT_WRITE.code,
  SECTION_TYPES.LESSON_SPLIT_TYPE.code,
  SECTION_TYPES.LESSON_XLS.code,
  SECTION_TYPES.LESSON_XLSX.code,
  SECTION_TYPES.LESSON_PPT.code,
  SECTION_TYPES.LESSON_PPTX.code,
  SECTION_TYPES.LESSON_DOC.code,
  SECTION_TYPES.LESSON_DOCX.code,
  SECTION_TYPES.LESSON_TEXT.code
];

export const SECTIONS_CAN_BE_PDF = [
  SECTION_TYPES.LESSON_DOC.code,
  SECTION_TYPES.LESSON_DOCX.code,
  SECTION_TYPES.LESSON_PPT.code,
  SECTION_TYPES.LESSON_PPTX.code,
  SECTION_TYPES.LESSON_TEMP_FILE.code,
  SECTION_TYPES.LESSON_XLS.code,
  SECTION_TYPES.LESSON_XLSX.code,
  SECTION_TYPES.LESSON_PDF.code,
  SECTION_TYPES.LESSON_PDF_IMAGE.code,
  SECTION_TYPES.LESSON_MATERIAL.code,
  SECTION_TYPES.LESSON_TEXT.code
]
